export enum HolidayType {
  MERCANTILE_HOLIDAY = 'Mercantile Holiday',
  POYA_DAY = 'Poya Day',
  EVENING_HALFDAY = 'Evening Halfday',
  MORNING_HALFDAY = 'Morning Halfday',
  PUBLIC_HOLIDAY = 'Public Holiday',
  COMPANY_HOLIDAY = 'Company Holiday',
  BANK_HOLIDAY = 'Bank Holiday',
}
